import "./tab.scss";
import { useEffect, useState, useCallback, useRef } from "react";
import Button from "../button/button";
import AddNoteComponent from "../addNote/addNote";
import AddTodoComponenet from "../addTodo/addTodo";
import AddChequeComponent from "../addCheque/addCheque";
import AddDocumentComponent from "../addDocument/addDocument";
import AddNoteIcon from "../../assets/images/note.svg";
import TodoIcon from "../../assets/images/todo.svg";
import ChequeIcon from "../../assets/images/cheque.svg";
import ArchiveIcon from "../../assets/images/archive.svg";

export default function Tab({getCheques,getTodos, getNotes, getDocuments, date, currentDate}) {
  const [action, setAction] = useState("");
  const [visibility, setVisibility] = useState("visible")
  const tabsRef = useRef(null);

  // useCallback causes unnecessary re-renders, but here it's needed to avoid adding handleResize to useEffect dependencies
  const handleResize = useCallback(() => {
    const el = tabsRef.current;
    if (!el) return;
    const hasVerticalOverflow = el.scrollHeight > el.clientHeight;
    const hasHorizontalOverflow = el.scrollWidth > el.clientWidth;
    setVisibility(hasHorizontalOverflow ? "visible" : "hidden");
  }, []);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  const scrollTabs = (direction) => {
    const el = tabsRef.current;
    if (!el) return;
    const scrollAmount = 100;
    el.scrollBy({
      left: direction === "right" ? scrollAmount : -scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div className="tab">
      <div className={`arrow rightArrow ${visibility}`} onClick={() => scrollTabs("right")}></div>
      <div className="tabWrapper">
        <div className="tabs" ref={tabsRef}>
          <div className="actions">
            <Button text="برای انجام" icon={TodoIcon} onClick={() => setAction("addTodo")} active={action === "addTodo"} />
            <Button text="ایجاد یادداشت" icon={AddNoteIcon} onClick={() => setAction("addNote")} active={action === "addNote"} />
            <Button text="صدور چک" icon={ChequeIcon} onClick={() => setAction("addCheque")} active={action === "addCheque"} />
            <Button text="آرشیو اسناد" icon={ArchiveIcon} onClick={() => setAction("addDocument")} active={action === "addDocument"} />
          </div>
        </div>
        <div className="action" >
          {action === "addNote" && <AddNoteComponent date={date} afterAddNote={getNotes} onClose={() => setAction("")} />}
          {action === "addTodo" && <AddTodoComponenet currentDate={currentDate} afterAddTodo={getTodos} onClose={() => setAction("")} />}
          {action === "addCheque" && <AddChequeComponent currentDate={currentDate} afterAddCheque={getCheques} onClose={() => setAction("")} />}
          {/* {action === "addDocument" && <AddDocumentComponent currentDate={currentDate} afterAddDocument={getDocuments} onClose={() => setAction("")} />} */}
          {action === "addDocument" && <AddDocumentComponent currentDate={currentDate} afterAddDocument={getDocuments} onClose={() => setAction("")} />}
        </div>
      </div>
      <div className={`arrow leftArrow ${visibility}`} onClick={() => scrollTabs("left")}></div>
    </div>
  );
}
